import React from 'react';
import IconSelector from '@ibibo/icon-selector';
import * as S from './MyProgressBar.styles';

const MypProgressBar = ({data}) => {
  return (
    <S.MypProgressBarContainer>
      <div className="td2 flexOne">
        {data?.travelCompleted?.percentage == 100 ? (
          <S.CompeletedWrapper>
            <IconSelector iconKey="greenmultitick" /> Milestone Compeleted
          </S.CompeletedWrapper>
        ) : null}
        <div className="makeFlex vrtlCenter">
          <div className="tdProgressBar">
            <div
              className={`tdBarComp`}
              style={{width: `${data?.travelCompleted?.percentage}%`}}
            ></div>
            <div
              className={`tdBarTravel`}
              style={{
                width: `${data?.travelCompleted?.percentage + data?.yetToCompleted?.percentage}%`,
              }}
            ></div>
          </div>
          <p className="font12 lineHeight16 latoBold appendLeft4 secondaryTxt">
            {data?.totalAmount}
          </p>
        </div>
        <ul className="makeFlex appendTop10">
          {data?.travelCompleted && (
            <li className="makeFlex vrtlCenter">
              <span className="bulletCompleted"></span>
              <span className="appendLeft8 font12 lineHeight16 secondaryTxt">
                {data?.travelCompleted?.primaryText}{' '}
                <span className="latoBlack appendLeft2">
                  {' '}
                  {data?.travelCompleted?.secondaryText}
                </span>
              </span>
            </li>
          )}
          {data?.yetToCompleted?.primaryText && (
            <li className="makeFlex vrtlCenter appendLeft20">
              <span className="bulletYetToComplete"></span>
              <span className="appendLeft8 font12 lineHeight16 secondaryTxt latoBlack">
                {data?.yetToCompleted?.primaryText} {data?.yetToCompleted?.secondaryText}
              </span>
            </li>
          )}
        </ul>
      </div>
    </S.MypProgressBarContainer>
  );
};

export default MypProgressBar;
